import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "http://localhost:8004";
// export const baseURL = "https://backend.acrosstour.tech";
export const baseURL = "https://test-backend.acrosstour.tech";
// export const baseURL = "https://acrosstours-backend.siglonet.com";

const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
